import styled from 'styled-components';
import { color } from 'theme';
import { GREY_300, GREY_400 } from '../../../../../constants';

export const UserItemContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    margin: 0.5rem 0.75rem;
    border-radius: 0.5rem;
    box-shadow: 0 0 1px 1px ${color('border.divider')};
    background: ${color('background.secondary')};
`;

export const UserItemInfo = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 0.125rem;
    min-width: 0;
    overflow: hidden;
`;

export const UserItemTitle = styled.span`
    display: flex;
    align-items: center;
    gap: 0.375rem;
    font-size: 0.9375rem;
    font-weight: 400;
    color: ${GREY_400};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    svg {
        width: 0.875rem;
        height: 0.875rem;
        flex-shrink: 0;
        color: ${GREY_300};
    }
`;

export const UserItemSubtitle = styled.span`
    display: flex;
    align-items: center;
    gap: 0.375rem;
    font-size: 0.8125rem;
    font-weight: 300;
    color: ${GREY_300};
    font-family: monospace;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    svg {
        width: 0.75rem;
        height: 0.75rem;
        flex-shrink: 0;
    }
`;

export const UserItemActions = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;
